import { render, staticRenderFns } from "./MobileSelectItem.vue?vue&type=template&id=00c45200&scoped=true"
import script from "./MobileSelectItem.vue?vue&type=script&lang=js"
export * from "./MobileSelectItem.vue?vue&type=script&lang=js"
import style0 from "./MobileSelectItem.vue?vue&type=style&index=0&id=00c45200&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c45200",
  null
  
)

export default component.exports